import styled, { StyledComponent } from 'styled-components';

export const ItemOption: StyledComponent<'div', any> = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  height: 32px;
  background: #fff;
  gap: 8px;

  &:hover {
    background: #e6edff;
  }

  &.disabled {
    opacity: 0.4;
  }
`;

export const ItemOptionContent = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.65);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
`;

export const StatusTag = styled.span`
  color: rgba(0, 0, 0, 0.45);
  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  margin-right: 5px;
`;
